export enum Dimensions {
    d0 = "0rem",
    d1 = ".0625rem", // 1px
    d2 = ".125rem", // 2px
    d4 = ".25rem", // 4px
    d6 = ".375rem", // 6px
    d8 = ".5rem", // 8px
    d9 = ".5625rem", // 9px
    d10 = ".625rem", // 10px
    d11 = ".6875rem", // 11px
    d12 = ".75rem", // 12px
    d13 = ".8375rem", // 13px
    d14 = ".875rem", // 14px
    d15 = ".9375rem", // 15px
    d16 = "1rem", // 16px
    d18 = "1.125rem", // 18px
    d20 = "1.25rem", // 20px
    d22 = "1.375rem", // 22px
    d24 = "1.5rem", // 24px
    d26 = "1.625rem", // 26px
    d28 = "1.75rem", // 28px
    d30 = "1.875rem", // 32px
    d32 = "2rem", // 32px
    d36 = "2.25rem", // 36px
    d38 = "2.375rem", // 38px
    d40 = "2.5rem", // 40px
    d44 = "2.75rem", // 44px
    d48 = "3rem", // 48px
    d52 = "3.25rem", // 52px
    d54 = "3.375rem", // 54px
    d56 = "3.5rem", // 56px
    d60 = "3.75rem", // 60px
    d64 = "4rem", // 64px
    d72 = "4.5rem", // 72px
    d80 = "5rem", // 80px
    d92 = "5.75rem", // 92px
    d96 = "6rem", // 96px
    d104 = "6.5rem", // 104px
    d112 = "7rem", // 112px
    d120 = "7.5rem", // 120px
    d128 = "8rem", // 128px
    d152 = "9.5rem", // 152px
    d160 = "10rem", // 160px
    d176 = "11rem", // 176px
    d192 = "12rem", // 192px
    d208 = "13rem", // 208px
    d224 = "14rem", // 224px
}
